<template>
    <section>
        <v-container class="nav">
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiCloseOutline }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2>Exclusions</h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>

        <div class="exclu-main-wrapper d-flex justify-space-around flex-wrap">
            <div class="exclu-col-content">
                <div class="content">
                    <h3>EXCLUSIONS, LIMITATIONS & NON-COVERAGE</h3>
                    <v-divider />
                    <p>
                        An illness, injury or condition shall be considered pre-existing if
                        it existed before the Effective Date of the Member's coverage, the
                        natural history of which can be medically determined to have started
                        prior to the effective date of coverage or at the time of processing
                        of the Member's Application, whether or not the Member was aware of
                        such illness, Injury or condition.
                    </p>
                    <h4>
                        Pre-existing Conditions shall include the following illnesses,
                        injuries or conditions, but not to the exclusion of all others
                        including their complications and sequelae:
                    </h4>
                    <ul v-for="(excluNonCoverage, i) in excluNonCoverages" :key="i">
                        <li>{{ excluNonCoverage }}</li>
                    </ul>
                    <p>
                        Pre-existing Condition shall only be covered after one year from
                        Effective Date of the Member's coverage provided that there is no
                        failure to disclose, misrepresent or conceal, Material Information
                        in the original Application or Application for reactivation.
                    </p>
                    <p>
                        Notwithstanding the disclosure by the Member of a pre-existing
                        condition, HMI may permanently exclude from cover or limit coverage
                        a specific medical condition, illnesses or injury upon written
                        notice to the member.
                    </p>
                    <p>
                        Diagnostic procedures undertaken to determine the existence of a
                        Pre-existing Condition is a covered expense provided that the result
                        of diagnostic procedure is negative for the existence of the
                        pre-existing condition.
                    </p>
                </div>
            </div>

            <div class="exclu-col-content">
                <h3>EXCLUSIONS FROM COVERAGE</h3>
                <v-divider />
                <h4>
                    The following shall fall under the exclusion of medical benefits.
                </h4>
                <ul v-for="(excluCoverage, i) in excluCoverages" :key="i">
                    <li>{{ excluCoverage }}</li>
                </ul>
                <ul>
                    <li>
                        Additional hospital charges and physician's fees resulting from:
                        <ul>
                            <li>
                                Room-upgrading beyond twenty-four (24) hours during Emergency
                                Conditions;
                            </li>
                            <li>
                                Extension of hospital stay despite the release of discharge
                                order from Member's Attending Physician;
                            </li>
                            <li>
                                Fees of the assistant surgeons for surgeries with less than 250
                                RUV units / resident doctors who assisted the Attending
                                Physician in the process of rendering the medical services shall
                                not be chargeable to the Member and/or HMI except for hospitals
                                that do not have resident physicians to assist during surgeries
                                subject to the prior approval of HMI.
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
import { mdiCloseOutline } from '@mdi/js'

export default {
    data: () => ({
        mdiCloseOutline,
        excluNonCoverages: [
            'Tumor / Cyst of Internal Organs',
            'Hemorrhoids / Anal Fistula',
            'Diseased tonsils and sinus conditions requiring surgery',
            'Cataract / Glaucoma',
            'Pathological Abnormalities of nasal septum ot turbinates',
            'Goiter and other thyroid disorders',
            'Hernia / Benign Prostactic Hypertrophy',
            'Endometriosis',
            'Asthma / Chronic Obstructive Lung Disease',
            'Epilepsy',
            'Spinal column abnormalities',
            'Tuberculosis',
            'Cholecystitis',
            'Gastric or Duodenal Ulcer',
            'Hallux valgus',
            'Hypertension and other Cardiovascular diseases',
            'Calculi',
            'Tumors / Cyst on skin, muscular tissue, bone or any form of blood dyscrasis',
            'Diabetes Mellitus',
            'Cerebrovascular Accident / Transient Ischemic Attack'
        ],
        excluCoverages: [
            'Services from non-HMI affiliated physicians and/or non-HMI affiliated Hospitals and other health/medical providers, including  adverse medical conditions arising from treatment of the same. For emergency cases, services from non-HMI affiliated physicians and/or non-HMI affiliated hospitals and other health/medical providers may be covered by application for reimbursement, as stated in Article IV.3 of Availment and Claims Procedure.',
            'Services of a hospital Medico-legal officer or a Surgeon\'s Assistant.',
            'Services rendered not under HMI Service Agreement including adverse medical conditions arising from treatment of the same.',
            'Treatment of an injury attributable to a member\'s own misconduct, gross or contributory negligence, intemperate use of drugs, tobacco or alcoholic beverages, vicious or immoral acts, direct or indirect participation in the commission of a crime, violation of a law or ordinance and unnecessary exposure to imminent danger or hazard to hazardous undertaking / activities such as, but not limited to: professional athletes, skydiving, scuba diving, aircraft flying, and parachuting.',
            'Extra hospitalization services such as the use of non-emergency ambulance, personal items, private nurse or personal physician and discharge / take home medicines.',
            'Treatment of injuries or illness resulting from war, military/police/paramilitary service, rebellion and insurrection, riots, labor disputes and / or civil disturbance.',
            'Treatment of self-inflicted injuries, or illnesses or injuries resulting from tobacco, alcohol or drug abuse/addiction.',
            'Custodial, domiciliary, convalescent and intermediate care.',
            'Maternity care including all other conditions that may arise as a result/complication of pregnancy.',
            'Plastic and reconstructive surgery for congenital deformities and abnormalities and for cosmetic purposes.',
            'Experimental procedures, corrective procedures for errors of refraction, sex transformation, acupuncture and services related to fertility, infertility, artificial insemination and circumcision.',
            'Organ transplants and all expenses incurred in the process of organ donation and transplantation if the Member is the donor, and its complication.',
            'Hyperalimentation, radiotherapy, brachytherapy and cost of attendant services.',
            'Rehabilitation, speech therapy, psychiatric and psychological conditions (e.g. anxiety reaction, hyperventilation syndrome, panic attack, etc.).',
            'Medical services required by schools, or for obtaining/continuing employment, insurance or government licensing including costs of medical certificates.',
            'Hernia, cysto/rectocele, uterine prolapse, sexually transmitted diseases, hepatitis B, mitral valve prolapse, cerebral aneurysm and medical conditions arising from such,	',
            'Cerebral palsy, mental retardation and similar medical conditions.',
            'Corrective appliances, artificial aids, orthopedic/prosthetic devices, durable medical equipments, and oxygen used outside of covered Emergency Room / In-patient care.',
            'Vaccines, screening and desensitization tests.',
            'Oral surgeries.',
            'Any medical condition / complication manifested during the treatment / management of conditions excluded by this Agreement.',
            'All other items not directly related to the medical management of the patient such as mineral water, extra food, television and other amenities.',
            'Charges beyond HMI limits on daily room rates and accompanying rate incrementals for professional fees, diagnostic procedures, laboratory examinations, and all other ancillary medical services.  The rate incrementals for diagnostic procedures, laboratory examinations and all other 	ancillary medical services shall be computed at no less than thirty percent (30%) of the bills based on the actual incremental 	rates of the respective hospital for these services.',
            'Diseases declared \'epidemics\' and \'pandemic\' by the Department of Health (DOH), World Health Organization (WHO) or other recognized health authority.',
            'Benefits covered by Philhealth and all other government funded healthcare entitlements as provided  by law.',
            'Pain Management for Chronic Pain Syndrome.'
        ]
    })
}
</script>

<style scoped>
section {
  background-image: url("../../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}
.exclu-col-content {
  width: 700px;
  margin: 20px auto;
}

.content {
  width: 100%;
  margin: auto;
}
.content p {
  text-align: justify;
  margin-top: 15px;
}
.exclu-col-content h3 {
  font-size: 30px;
  color: #1b5e20;
}
.exclu-col-content h4 {
  width: 80%;
  margin-top: 20px;
  text-align: justify;
}

.exclu-col-content ul {
  width: 80%;
}
.exclu-col-content ul li {
  padding-top: 20px;
  font-size: 17px;
  text-align: justify;
}
@media (max-width: 390px) {
  .page-icon {
    display: none;
  }
}
@media (max-width: 599px) {
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    padding-top: 10px;
    font-size: 25px;
  }
  .exclu-col-content {
    width: 90%;
    /* border: 1px solid red; */
  }
  .exclu-col-content h4 {
    width: 100%;
  }
  .exclu-col-content h3 {
    text-align: center;
    font-size: 23px;
  }
  .exclu-col-content ul {
    width: 95%;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    padding-top: 10px;
    font-size: 30px;
  }
  .exclu-col-content {
    width: 80%;
  }
  .exclu-col-content h3 {
    text-align: center;
    font-size: 25px;
  }
  .exclu-col-content ul {
    width: 95%;
  }
}
@media (min-width: 968px) and (max-width: 1264px) {
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    padding-top: 10px;
    font-size: 30px;
  }
  .exclu-col-content {
    width: 45%;
  }
  .exclu-col-content h3 {
    text-align: center;
    font-size: 25px;
  }
  .exclu-col-content ul {
    width: 95%;
  }
}
@media (min-width: 1264px) and (max-width: 1904px) {
  .exclu-col-content {
    width: 45%;
  }
  .exclu-col-content h3 {
    text-align: center;
  }
  .exclu-col-content ul {
    width: 95%;
  }
}
</style>
